"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var de_AT_json_1 = __importDefault(require("./strings/de-AT.json"));
var de_DE_json_1 = __importDefault(require("./strings/de-DE.json"));
var en_AU_json_1 = __importDefault(require("./strings/en-AU.json"));
var en_CA_json_1 = __importDefault(require("./strings/en-CA.json"));
var en_FI_json_1 = __importDefault(require("./strings/en-FI.json"));
var en_GB_json_1 = __importDefault(require("./strings/en-GB.json"));
var en_NO_json_1 = __importDefault(require("./strings/en-NO.json"));
var en_NZ_json_1 = __importDefault(require("./strings/en-NZ.json"));
var en_US_json_1 = __importDefault(require("./strings/en-US.json"));
var es_ES_json_1 = __importDefault(require("./strings/es-ES.json"));
var es_MX_json_1 = __importDefault(require("./strings/es-MX.json"));
var es_US_json_1 = __importDefault(require("./strings/es-US.json"));
var fi_FI_json_1 = __importDefault(require("./strings/fi-FI.json"));
var fr_BE_json_1 = __importDefault(require("./strings/fr-BE.json"));
var fr_CA_json_1 = __importDefault(require("./strings/fr-CA.json"));
var fr_FR_json_1 = __importDefault(require("./strings/fr-FR.json"));
var it_IT_json_1 = __importDefault(require("./strings/it-IT.json"));
var nl_BE_json_1 = __importDefault(require("./strings/nl-BE.json"));
var no_NO_json_1 = __importDefault(require("./strings/no-NO.json"));
var pt_BR_json_1 = __importDefault(require("./strings/pt-BR.json"));
var ru_RU_json_1 = __importDefault(require("./strings/ru-RU.json"));
var sv_SE_json_1 = __importDefault(require("./strings/sv-SE.json"));
var zh_CN_json_1 = __importDefault(require("./strings/zh-CN.json"));
var strings = {
    "de_AT": de_AT_json_1.default,
    "de_DE": de_DE_json_1.default,
    "en_AU": en_AU_json_1.default,
    "en_CA": en_CA_json_1.default,
    "en_FI": en_FI_json_1.default,
    "en_GB": en_GB_json_1.default,
    "en_NO": en_NO_json_1.default,
    "en_NZ": en_NZ_json_1.default,
    "en_US": en_US_json_1.default,
    "es_ES": es_ES_json_1.default,
    "es_MX": es_MX_json_1.default,
    "es_US": es_US_json_1.default,
    "fi_FI": fi_FI_json_1.default,
    "fr_BE": fr_BE_json_1.default,
    "fr_CA": fr_CA_json_1.default,
    "fr_FR": fr_FR_json_1.default,
    "it_IT": it_IT_json_1.default,
    "nl_BE": nl_BE_json_1.default,
    "no_NO": no_NO_json_1.default,
    "pt_BR": pt_BR_json_1.default,
    "ru_RU": ru_RU_json_1.default,
    "sv_SE": sv_SE_json_1.default,
    "zh_CN": zh_CN_json_1.default,
};
var StringProvider = /** @class */ (function (_super) {
    __extends(StringProvider, _super);
    function StringProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onIntlError = function (err) {
            if (window.location.hostname === "localhost" && window.zlurlparams.debug) {
                if (err.indexOf("Missing message") >= 0) {
                    var mm = err.split('"')[1];
                    var longsplit = err.split(',,,');
                    var enVal = longsplit[longsplit.length - 1];
                    window.missingStrings = window.missingStrings || {};
                    if (window.missingStrings[mm] === undefined) {
                        window.missingStrings[mm] = enVal;
                        console.log(err, { total: Object.keys(window.missingStrings).length, ids: Object.keys(window.missingStrings) });
                        fetch("http://" + window.location.hostname + ":7001/missing?id=" + mm + "&val=" + enVal);
                    }
                }
            }
        };
        return _this;
    }
    StringProvider.prototype.render = function () {
        var lang = navigator.language || navigator.browserLanguage || "en-CA";
        if (window.zlurlparams.locale) {
            lang = window.zlurlparams.locale;
        }
        var language = lang.split(/[-_]/)[0];
        var locale = lang.split(/[-_]/)[1];
        var messageLang = lang.replace("-", "_");
        if (strings[messageLang] === undefined) {
            messageLang = language + "_" + language.toUpperCase();
            if (strings[messageLang] === undefined) {
                for (var item in strings) {
                    var regEx = RegExp("^" + language);
                    if (regEx.test(item)) {
                        messageLang = strings[item];
                        break;
                    }
                }
            }
        }
        return (react_1.default.createElement(react_intl_1.IntlProvider, { onError: this.onIntlError, locale: locale, messages: strings[messageLang] !== undefined ? strings[messageLang] : strings["en_US"] }, this.props.children));
    };
    return StringProvider;
}(react_1.Component));
exports.default = StringProvider;
//# sourceMappingURL=BYOStrings.js.map